class Scrollable {
    constructor(scrollable) {
        this.scrollable = scrollable;

        this.init();
    }

    /**
     * Initialise component and setup event listeners
     * @returns {void}
     */
    init() {
        const buttons = this.scrollable.querySelectorAll("[data-scroll]");

        if (!buttons.length) return;

        window.addEventListener(
            "scroll",
            this.scrollspy.bind(this),
            // this.debounce(this.scrollspy, 250).bind(this),
        );

        // Add a click event handler to each anchor
        buttons.forEach((button) => {
            button.addEventListener("click", this.scroll.bind(this));
        });
    }

    /**
     * Scroll to element
     * Sets anchor current status
     * @param {Event} e
     */
    scroll(e) {
        e.preventDefault();

        // Current scroll position
        const scroll = window.scrollY;

        let button = e.currentTarget;
        let parent = button.parentNode;

        // Remove all current selected buttons
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute("aria-selected", "false"));

        // Set this button as selected
        button.setAttribute("aria-selected", "true");

        // Scroll to target element (with offset)
        let offset = parent.getBoundingClientRect().height;
        let target = document.querySelector(button.getAttribute("href"));
        let box = target.getBoundingClientRect();
        let top = box.top + scroll - offset;
        window.scrollTo(0, top);
    }

    /**
     * Detect element in view upon scrolling
     * Sets relevant anchor current status
     * @param {Event} e
     */
    scrollspy(e) {
        // Current scroll position
        const scroll = window.scrollY;
        const offset = 100;
        const elements = document.querySelectorAll("[data-scrollspy-item]");

        // Find element in view
        const position = [...elements]
            .map((element) => {
                const parent = document.querySelector(
                    element.dataset.scrollspyParent,
                );
                if (parent.getAttribute("aria-hidden") != "true") {
                    const box = element.getBoundingClientRect();
                    const top = box.top + scroll - offset;
                    const bottom = box.bottom + scroll - offset;
                    // console.log(scroll, box, element);
                    return { top, bottom, element };
                } else {
                    return { top: -1, bottom: -1 };
                }
            })
            .find(({ top, bottom }) => this.between(scroll, top, bottom));

        // Find relevant anchor element
        const id = position?.element?.getAttribute("id");
        const target = document.querySelector(`[href="#${id}"]`);

        // Remove all current selected buttons
        target?.parentNode
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => t.setAttribute("aria-selected", "false"));

        // Set this button as selected
        target?.setAttribute("aria-selected", "true");
    }

    // debounce(callback, wait) {
    //     let timeout;
    //     return (...args) => {
    //         const context = this;
    //         clearTimeout(timeout);
    //         timeout = setTimeout(() => callback.apply(context, args), wait);
    //     };
    // }

    /**
     * Check if number is between two values
     * @param {Number} value
     * @param {Number} floor
     * @param {Number} ceil
     * @returns {Number}
     */
    between(value, floor, ceil) {
        return value >= floor && value <= ceil;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const scrollables = document.querySelectorAll("[data-scrollspy]");

    if (scrollables) {
        scrollables.forEach((scrollable) => {
            new Scrollable(scrollable);
        });
    }
});
